module.exports = __webpack_public_path__ + "static/media/animal.b88e9f93.png";